import { GlobalBanner } from "@/features/banner"
import { useOnboardingBannerText } from "../hooks/useOnboardingBannerText"
import { type OnboardingFormValues } from "../wizard"

type OnboardingBannerProps = Pick<
    OnboardingFormValues,
    "affiliateCode" | "journeyType" | "reward"
> & {
    recommendedSubscribedMaxPower: number | null
}

export function OnboardingBanner({
    affiliateCode,
    recommendedSubscribedMaxPower,
    reward,
    journeyType,
}: OnboardingBannerProps) {
    const bannerText = useOnboardingBannerText({
        affiliateCode,
        recommendedSubscribedMaxPower,
        reward,
        journeyType,
    })

    if (!bannerText) return null

    return <GlobalBanner>{bannerText}</GlobalBanner>
}

OnboardingBanner.messages = [...useOnboardingBannerText.messages] as const
